import React from "react";
import { TextField, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";

function SearchBar({ onSearch, role }) {
  const theme = useTheme();
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    onSearch(searchTerm);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <form className="formBox" onKeyDown={handleKeyDown}>
      <TextField
        variant="outlined"
        form="rounded"
        placeholder="Recherche"
        onChange={handleSearch}
        size="small"
        sx={{
          width: '372px',
          '& .MuiOutlinedInput-root': {
            color: theme.palette.text.primary,
            '& fieldset': {
              borderRadius: 2,
              borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
            },
            '&:hover fieldset': {
              borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
            },
            '&.Mui-focused fieldset': {
              borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
            },
          },
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette.text.secondary,
            opacity: 1,
          },
        }}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
      />
    </form>
  );
}

export default SearchBar;
